<template>
  <ReportSimpleDataTable
    reportTitle="Item History Detail Report"
    :urls="urls"
    :mandatory-filter="mandatoryFilters"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportSimpleDataTable from "@/own/components/reports/ReportSimpleDataTable.vue";
export default {
  name: "ItemHistoryDetail",
  components: { ReportSimpleDataTable },
  data: () => ({
    urls: {
      data_url: "/reports/reportItemHistoryDetail",
      show_url: "/reports/reportItemHistoryDetail/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
  computed: {
    mandatoryFilters: function () {
      const filters = [
        {
          name: "date_range",
          title: "Date range",
          valueFieldName: "",
        },
        {
          name: "warehouse",
          title: "Warehouse",
          valueFieldName: "",
        },
      ];

      if (!this.$store.getters.currentUser.data.is_client) {
        filters.push({
          name: "client",
          title: "Seller",
          valueFieldName: "",
        });
      }

      return filters;
    },
  },
};
</script>
